import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var AlignJustify = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M4 5h16v2H4zm0 4h16v2H4zm0 4h16v2H4zm2 4h12v2H6z", key: "k0" })));
});
AlignJustify.displayName = 'AlignJustify';
export var AlignJustifyDimensions = { height: 24, width: 24 };
